import { useRefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';
import { useState } from 'react';
import ArroweExpand from 'components/helpers/SvgIcon/icons/arrow-expand';
import ArrowCollapse from 'components/helpers/SvgIcon/icons/arrow-collape';

export interface filter {
  value: string;
  label: string;
  count: number;
  isRefined: boolean;
}

const LanguageFacet = () => {
  const [isOpen, setOpen] = useState(true);
  const dict = useSearchDictionary();
  const formatRefineList = useRefinementList({
    attribute: 'productLanguages',
    showMore: true,
    limit: 10,
    showMoreLimit: 30,
    sortBy: ['name:asc'],
  });

  const handleTypeSelect = (facet: string) => {
    formatRefineList.refine(facet);
  };

  return (
    <div>
      <div
        className={classnames(
          'text-blue-night',
          'mb-4',
          'flex',
          'w-full',
          'justify-between',
          'lg:text-lg'
        )}
      >
        <button
          type="button"
          onClick={() => setOpen(!isOpen)}
          className={classnames('flex', 'w-full', 'justify-between', 'text-body', 'font-medium')}
        >
          <span>{dict.productListLanguage}</span>
          <span>
            {isOpen ? (
              <ArroweExpand className={classnames('text-blue-morning')} />
            ) : (
              <ArrowCollapse className={classnames('text-blue-morning')} />
            )}
          </span>
        </button>
      </div>
      {isOpen && (
        <>
          {formatRefineList.items.map((x) => {
            const checkboxId = x.value.replace(/\s+/g, '');
            return (
              <div key={checkboxId} className={classnames('flex', 'w-full', 'pb-4', 'text-black')}>
                <input
                  type="checkbox"
                  name={x.value}
                  value={x.value}
                  id={checkboxId}
                  checked={x.isRefined}
                  onChange={(e) => handleTypeSelect(e.currentTarget.value)}
                  className={classnames('min-w-[24px]', 'h-6', 'accent-blue-morning')}
                />
                <label htmlFor={checkboxId} className={classnames('flex', 'w-full')}>
                  <span className={classnames('pl-2', 'w-full')}>{x.label}</span>
                  <span className={classnames('pr-0.5', 'text-right')}>{x.count}</span>
                </label>
              </div>
            );
          })}
          {formatRefineList.canToggleShowMore && (
            <button
              type="button"
              className={classnames('text-theme-btn-link-text', 'underline')}
              onClick={() => {
                formatRefineList.toggleShowMore();
              }}
            >
              {formatRefineList.isShowingMore ? 'Show Less' : 'Show More'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default LanguageFacet;
